import React from "react";
import { Toast } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ErrorLevels } from "../../Constants";
import { setShowErrorToast } from "../../Reducer";
import "./ErrorToast.scss";

function ErrorToast() {
  const dispatch = useDispatch();
  const [t] = useTranslation();

  const show = useSelector((x) => x.error.show);
  const text = useSelector((x) => x.error.text);
  const level = useSelector((x) => x.error.level);

  const errorLevels = Object.fromEntries(
    Object.entries(ErrorLevels).map((a) => a.reverse())
  );

  return (
    <div className={`toast-wrapper`}>
      <Toast
        show={show}
        delay={5000}
        onClose={() => dispatch(setShowErrorToast(false))}
        autohide
        position="top-end"
        className={`toast ${errorLevels[level]}`}
      >
        {/* <Toast.Header>{t(errorLevels[level])}</Toast.Header> */}
        <Toast.Body>{text}</Toast.Body>
      </Toast>
    </div>
  );
}

export { ErrorToast };
